import type { RouteObject } from 'react-router-dom';
import Layout from '../components/feature/Layout';
import Home from '../pages/home/page';
import CategoryPage from '../pages/category/page';
import DetailPage from '../pages/detail/page';
import NewsListPage from '../pages/news/page';
import NewsDetailPage from '../pages/news/detail/page';
import SearchPage from '../pages/search/page';
import AboutPage from '../pages/about/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: 'category/:type', element: <CategoryPage /> },
      { path: 'detail/:id', element: <DetailPage /> },
      { path: 'news', element: <NewsListPage /> },
      { path: 'news/:id', element: <NewsDetailPage /> },
      { path: 'search', element: <SearchPage /> },
      { path: 'about', element: <AboutPage /> },
      { path: '*', element: <NotFound /> },
    ],
  },
];

export default routes;